// extracted by mini-css-extract-plugin
module.exports = {"section":"styles__section___11APw","button":"styles__button___3d99d"};